import { render, staticRenderFns } from "./FreeBlock.vue?vue&type=template&id=675a820c&scoped=true"
import script from "./FreeBlock.vue?vue&type=script&lang=ts"
export * from "./FreeBlock.vue?vue&type=script&lang=ts"
import style0 from "./FreeBlock.vue?vue&type=style&index=0&id=675a820c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675a820c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675a820c')) {
      api.createRecord('675a820c', component.options)
    } else {
      api.reload('675a820c', component.options)
    }
    module.hot.accept("./FreeBlock.vue?vue&type=template&id=675a820c&scoped=true", function () {
      api.rerender('675a820c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/FreeBlock.vue"
export default component.exports